import { config } from 'utils/config'

export const getClientKey = () => {
  switch (config.apiEnv) {
    case 'development':
      return 'sdk-wT4iF1nGAdAdLwAB'

    case 'staging':
      return 'sdk-BJm733b37xoo9HAL'

    case 'production':
      return 'sdk-aNjWozEOWjBCkJhr'
  }
}
